/**
 * 通过 Vue 实例创建一个全局事件总线
 */
import Vue from 'vue';
import { sendToBackgroundViaRelay } from '@plasmohq/messaging';
import * as Sentry from '@sentry/vue';

const ExtensionActionName = 'verify';

const EventBus = new Vue();

export const EventType = {
  Extension: 'extension',
};

EventBus.$on(EventType.Extension, (params) => {
  const { action, payload } = params;
  const realPayload = {
    ...payload,
    appTitle: process.env.VUE_APP_TITLE,
  };

  try {
    sendToBackgroundViaRelay({ name: ExtensionActionName, body: { action, payload: realPayload } });
  } catch (err) {
    Sentry.captureException(err);
  }
});

export default EventBus;
